module.exports = __webpack_public_path__ + "static/media/contact-info-icon2.df4fdedf.svg";